import { render } from "./DoctorList.vue?vue&type=template&id=50b39eb8&scoped=true&ts=true"
import script from "./DoctorList.vue?vue&type=script&lang=ts"
export * from "./DoctorList.vue?vue&type=script&lang=ts"

import "./DoctorList.vue?vue&type=style&index=0&id=50b39eb8&lang=scss&scoped=true"

import exportComponent from "D:\\Work\\HESEL\\DCS\\Client\\vuejs-dcs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50b39eb8"]])

export default __exports__